import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out
  const [needsSetup, setNeedsSetup] = useState(null);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/setup-status");
      setNeedsSetup(data.needs_setup);
    } catch {
      setNeedsSetup(false);
    }
    const token = localStorage.getItem("token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("token");
      setUser(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const login = (token, userData) => {
    localStorage.setItem("token", token);
    setUser(userData);
    setNeedsSetup(false);
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, needsSetup, setNeedsSetup, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
